
import { defineComponent, ref } from 'vue'

export default defineComponent({
  components: {},
  props: {
    ghost: { type: Boolean, default: true },
    title: { type: String, default: '' },
    content: { type: String, default: '' }
  },
  setup() {
    // eslint-disable-next-line no-undef
    const headerRef = ref<ComponentRef>(null)
    return { headerRef }
  }
})
